import { render, staticRenderFns } from "./HerbariumItemPage.vue?vue&type=template&id=35916894&scoped=true&"
import script from "./HerbariumItemPage.vue?vue&type=script&lang=js&"
export * from "./HerbariumItemPage.vue?vue&type=script&lang=js&"
import style0 from "./HerbariumItemPage.vue?vue&type=style&index=0&id=35916894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35916894",
  null
  
)

export default component.exports